import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/video-diagnostic/Success.png'


const _withScopeId = n => (_pushScopeId("data-v-45fe6ad2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_2 = { class: "font-bold text-xl sm:text-4xl lg:text-xl xl:text-4xl" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "py-4 sm:py-10 lg:py-4 xl:py-10" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full row-span-2 mx-auto sm:mx-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-fit row-span-2 mx-auto sm:mx-0 text-sm sm:text-base lg:text-sm xl:text-base" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "m-auto",
      src: _imports_0,
      alt: ""
    })
  ])
], -1))
const _hoisted_7 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base mt-6" }

import DiagnosticSection from '@/components/video-diagnostic/DiagnosticSection.vue'
import { Stage, QualityScore } from '@/types/enums/video-diagnostic.enum'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

interface ExcellentQualityTestEmits {
  (e: 'nextStage'): void
  (e: 'updateToggle'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ExcellentQuality',
  props: {
  stage: {
    type: Number,
    required: true,
  },
  totalQualityScore: {
    type: Number,
    required: true,
  },
},
  emits: ["nextStage", "updateToggle"],
  setup(__props, { emit: __emit }) {

const props = __props
const i18n = useI18n()

const emit = __emit

const qualityScore = computed(() =>
  props.totalQualityScore === QualityScore.Excellent ? 'excellent' : 'good',
)

const displayQualityScore = computed(() => {
  const color = qualityScore.value === 'excellent' ? 'text-blue-500' : 'text-green-500'
  return `<span class="${color}">${i18n.t(
    `video-diagnostic.quality-score.${qualityScore.value}`,
  )}</span>`
})

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createBlock(DiagnosticSection, {
    id: _unref(Stage).QUALITY,
    class: _normalizeClass(
      __props.stage === _unref(Stage).QUALITY || __props.stage === _unref(Stage).RESULTS
        ? 'block'
        : 'hidden md:block opacity-30 pointer-events-none'
    )
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, [
          _createElementVNode("p", {
            innerHTML: _ctx.$t('video-diagnostic.expected-quality', { qualityScore: displayQualityScore.value })
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            innerHTML: 
              _ctx.$t('video-diagnostic.expected-quality-detail', { qualityScore: displayQualityScore.value })
            
          }, null, 8, _hoisted_5),
          _createVNode(_component_SvgIcon, {
            icon: 'info',
            class: "cursor-pointer text-gray-400 hover:text-black pl-1",
            "inherit-fill": true,
            height: "15",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('updateToggle')))
          })
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: _normalizeClass([{ 'opacity-30 pointer-events-none': __props.stage === _unref(Stage).RESULTS }, "text-white border-2 rounded-md border-white bg-primary-color py-2 px-4"]),
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('nextStage')))
        }, _toDisplayString(_ctx.$t('video-diagnostic.finish-up')), 3)
      ])
    ]),
    _: 1
  }, 8, ["id", "class"]))
}
}

})